import BaseService from "../../BaseService";

export default class MonitoringService extends BaseService {

  constructor() {
    super('monitoring')
  }

  async isUserAllowed() {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/allowed`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

}
